<template>
  <CNavItem
    v-for="(item, index) in list"
    :key="index"
    :class="item.isActive ? 'active' : ''"
  >
    <CNavLink href="javascript:void(0);" @click="onClickMenuItem(item.to)">
      <CIcon customClassName="nav-icon" :icon="item.icon" />
      {{ item.name }}
    </CNavLink>
  </CNavItem>
</template>

<script>
import routerPublisher from '@/publisher/router'

export default {
  name: 'PublisherSidebarItem',

  props: {
    list: {
      required: true,
    },
  },

  methods: {
    onClickMenuItem(dest) {
      routerPublisher.push({ path: dest })
    },
  },
}
</script>
